import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { Router } from '@angular/router';
import { NavigationService } from 'app/core/navigation/navigation.service';
import { PermissionService } from './permission.service';

/** Bandeau affiché pendant un aperçu de rôle, pour en sortir à tout moment. */
@Component({
    selector: 'app-role-preview-banner',
    standalone: true,
    changeDetection: ChangeDetectionStrategy.Default,
    imports: [MatButtonModule, MatIconModule],
    template: `
        @if (permissionService.previewRoleName; as roleName) {
            <div class="preview-banner" role="status">
                <mat-icon class="icon-size-5" svgIcon="heroicons_outline:eye"></mat-icon>
                <span>
                    Aperçu de l'interface avec le rôle <strong>{{ roleName }}</strong> : les données affichées restent
                    celles de votre compte.
                </span>
                <button mat-flat-button class="preview-banner__exit" (click)="exit()">Quitter l'aperçu</button>
            </div>
        }
    `,
    styles: `
        .preview-banner {
            position: fixed;
            left: 50%;
            bottom: calc(1rem + env(safe-area-inset-bottom, 0px));
            z-index: 1000;
            display: flex;
            align-items: center;
            gap: 0.75rem;
            max-width: calc(100vw - 2rem);
            padding: 0.625rem 0.75rem 0.625rem 1rem;
            border-radius: 0.75rem;
            font-size: 0.875rem;
            color: #ffffff;
            background-color: #1e293b;
            box-shadow: 0 12px 32px rgba(15, 23, 42, 0.3);
            transform: translateX(-50%);
        }

        .preview-banner__exit {
            flex: 0 0 auto;
        }
    `,
})
export class RolePreviewBannerComponent {
    readonly permissionService = inject(PermissionService);
    private _navigationService = inject(NavigationService);
    private _router = inject(Router);

    exit(): void {
        this.permissionService.stopPreview();
        this._navigationService.get().subscribe();
        this._router.navigateByUrl('/administration/roles');
    }
}
